import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  ANALYTICS_EVENTS,
  HEADER_TOP_MENU,
  LoggingService
} from '@com-delta-idp/mnx-utils';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject, Subscription } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { CookieHelper } from '../../common/cookie-helper';
import { CountryLanguageHelper } from '../../common/country-language-helper';
import { DataLayer } from '../../common/datalayer/datalayer';
import { QueryStringHelper } from '../../common/query-string-helper';
import { ApplicationConfig } from '../../config/config';
import { UrlUtil } from '../../config/urlutil';
import { ICorporatePartner } from '../../corporate-partner/corporate-partner.interface';
import { ContentAccessibilityPopup } from '../../model/content/contentAccessibilityPopup.model';
import { ContentLogo } from '../../model/content/contentLogo.model';
import { AdobeDataLayerService } from '../../services/adobe-data-layer/adobe-data-layer';
import { CommonService } from '../../services/common.service';
import { ContentHeaderFooterService } from '../../services/content/contentheaderfooter.service';
import { CountryLanguageService } from '../../services/country_Language/country_Language.service';
import { FlyoutExternalSiteService } from '../../services/flyout-externalsite-service/flyout-externalsite.service';
import { SwitchingAccountService } from '../switching-account/switching-account.service';

@Component({
  selector: 'ngc-logo',
  templateUrl: './logo.component.html'
})
export class LogoComponent implements OnInit, OnDestroy {
  @Input() mobileDarkSiteLogo: boolean;
  @Input() isLightHeaderFooterEnable: boolean;
  @Input() displayBusinessTypeSection: boolean;
  @Input() corpPartner: ICorporatePartner;
  isBusiness = false;
  @ViewChild('triggerElement') triggerElement;
  public deepLinkCacheKey;
  bsModalRef: BsModalRef;
  config = {
    animated: false
  };

  axPopupContent: ContentAccessibilityPopup;
  public logo: ContentLogo;
  modalOnHiddenSubscription: Subscription;
  contentServiceHeaderFooterSubscribe: Subscription;
  private unsubscribe: Subject<void> = new Subject();
  private countryCode: any;
  showNewProfileSelector: boolean;

  constructor(
    private modalService: BsModalService,
    private changeDetection: ChangeDetectorRef,
    private contentService: ContentHeaderFooterService,
    public switchingAccountService: SwitchingAccountService,
    private datalayer: DataLayer,
    public el: ElementRef,
    private renderer: Renderer2,
    private appconfig: ApplicationConfig,
    private srv: CommonService,
    private FlyoutExternalSiteService: FlyoutExternalSiteService,
    private cookieHelper: CookieHelper,
    private urlUtil: UrlUtil,
    private countryLanguageHelper: CountryLanguageHelper,
    private countryLanguageService: CountryLanguageService,
    private _route: ActivatedRoute,
    private queryStringHelper: QueryStringHelper,
    private loggingService: LoggingService,
    private adobeDataLayer: AdobeDataLayerService
  ) {
    this.deepLinkCacheKey = this.getQueryParams('cacheKeySuffix');
  }

  ngOnInit() {
    this.contentService._isHeaderFooter
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((headerFooterFlag) => {
        if (headerFooterFlag) {
          if (this.contentService.contentHeaderFooter) {
            this.contentServiceHeaderFooterSubscribe =
              this.contentService.contentHeaderFooter
                .pipe(takeUntil(this.unsubscribe))
                .subscribe(
                  (data) => {
                    if (data) {
                      this.showNewProfileSelector =
                        !!data?.header?.enableNewProfileSelector;
                      this.axPopupContent = data.accessibilityPopup;
                      this.logo = data.logo;
                      this.srv.setAxPopupContent(this.axPopupContent);
                      if (this.showNewProfileSelector) {
                        const account =
                          this.switchingAccountService.getAccountCookie(
                            'account'
                          );
                        if (account && account.length) {
                          const parseAccount = JSON.parse(account);
                          this.isBusiness = parseAccount['isBusiness'];
                        }
                      }
                      this.changeDetection.detectChanges();
                    }
                  },
                  (err) => {
                    if (this.appconfig.onBrowser) {
                      this.loggingService.log('Caught Error: ' + err);
                    }
                  }
                );
          }
        }
      });
    this.switchingAccountService.corporatePartnerChange
      .pipe(takeUntil(this.unsubscribe), distinctUntilChanged())
      .subscribe((corpPartner: ICorporatePartner) => {
        this.corpPartner = corpPartner;
        this.corpPartner = this.srv.getCorpPartner(
          this.corpPartner.name,
          this.corpPartner,
          this.deepLinkCacheKey
        );
        this.changeDetection.detectChanges();
      });
  }

  getLogoUrl(logo) {
    if (logo) {
      if (logo.mainLogoUrl || logo.busiLogoUrl) {
        const prefCookie = this.cookieHelper.getCookies('prefUI');
        const appDomain = this.urlUtil.hostUrl;
        if (prefCookie) {
          if (prefCookie.length > 0) {
            const res = prefCookie.split('=');
            this.countryCode = res[1].split('-')[1];
            if (this.countryCode) {
              const urlcc = this.geturlccFromCLS(this.countryCode);
              if (this.appconfig.get('APP_DEFAULT_COUNTRY') !== urlcc) {
                if (this.corpPartner.displayBusinessLogo || this.isBusiness) {
                  this.logo.busiLogoUrl =
                    appDomain + '/' + urlcc + '/' + res[1].split('-')[0];
                  return this.logo.busiLogoUrl;
                } else {
                  const appendUrl = urlcc
                    ? urlcc + '/' + res[1].split('-')[0]
                    : '';
                  this.logo.mainLogoUrl = appDomain + '/' + appendUrl;
                  return this.logo.mainLogoUrl;
                }
              } else {
                if (this.corpPartner.displayBusinessLogo || this.isBusiness) {
                  this.logo.busiLogoUrl = this.logo.busiLogoUrl;
                  return this.logo.busiLogoUrl;
                } else {
                  this.logo.mainLogoUrl = this.logo.mainLogoUrl;
                  return this.logo.mainLogoUrl;
                }
              }
            }
          }
        }
      }
    }
  }

  geturlccFromCLS(countryCode) {
    let urlcc = '';
    this.countryLanguageService
      .countryLanguageDataFromAPI()
      .subscribe((countryLanguageData) => {
        if (countryLanguageData) {
          this.countryLanguageHelper.setData(countryLanguageData);
          urlcc = this.countryLanguageHelper.getCountryForCountryCode(
            this.countryCode
          ).urlcc;
        }
      });
    return urlcc;
  }

  open(hrefUrl: string, modalPopupFlag: string) {
    this.datalayer.setTrackingObjectProp1(
      ANALYTICS_EVENTS.HEADER_SKY_TEAM,
      this.triggerElement
    );

    this.adobeDataLayer.updateAnalytics(hrefUrl || '', HEADER_TOP_MENU.SKYTEAM);

    if (modalPopupFlag === 'false') {
      window.open(hrefUrl, '_blank');
    } else {
      this.FlyoutExternalSiteService.openFlyoutExtSiteModal(
        hrefUrl,
        this.el,
        this.renderer
      );
    }
  }

  homeClicked() {
    this.datalayer.setTrackingObjectProp1(
      ANALYTICS_EVENTS.HEADER_DELTA_LOGO,
      this.triggerElement
    );
    this.adobeDataLayer.updateAnalytics(
      this.logo?.mainLogoUrl || '/',
      HEADER_TOP_MENU.HOME
    );
  }

  ngOnDestroy() {
    if (this.modalOnHiddenSubscription) {
      this.modalOnHiddenSubscription.unsubscribe();
    }
    if (this.contentServiceHeaderFooterSubscribe) {
      this.contentServiceHeaderFooterSubscribe.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
    this.changeDetection.detach();
  }

  getQueryParams(queryParamName: string) {
    let queryParamValue;
    if (
      this._route.snapshot.queryParams &&
      this._route.snapshot.queryParams[queryParamName] !== undefined &&
      this._route.snapshot.queryParams[queryParamName] !== null
    ) {
      queryParamValue = this._route.snapshot.queryParams[queryParamName];
    } else {
      queryParamValue = undefined;
    }
    if (!queryParamValue) {
      queryParamValue =
        this.queryStringHelper.getParameterByName(queryParamName);
    }
    return queryParamValue;
  }
}
